import { render, staticRenderFns } from "./card-base-template.vue?vue&type=template&id=37fd6a6c&scoped=true"
import script from "./card-base-template.vue?vue&type=script&lang=js"
export * from "./card-base-template.vue?vue&type=script&lang=js"
import style0 from "./card-base-template.vue?vue&type=style&index=0&id=37fd6a6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fd6a6c",
  null
  
)

export default component.exports